import React, {useEffect, useRef, useState} from "react";
import "./OnlineStoreSubCat.scss";
import {
    BasketAddRemove,
    OnlineCategories,
    OnlineOff,
    OnlineSearch,
    OnlineSlider,
    OnlineSwiper,
    Slider
} from "../../Components";
import {StoreOnlineSubCatsData} from "./OnlineStoreSubCatService";
//import {sort} from "fusioncharts/datastore/operators";
import {useHistory, useParams} from "react-router-dom";
import {OnlineCatBar} from "../../Components/OnlineCatBar/OnlineCatBar";
import {useBasket, useDispatchBasket} from "../../hooks";
import {AddBasket, RemoveBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import {NextData} from "../Chat/ChatServices";
import {RangeSlider} from "@progress/kendo-react-inputs";
import Rodal from "rodal";
import useOnScreen from "../../hooks/useOnScreen";
import useWindowDimensions from "../../hooks/useWindowDimensions";

let selBra = []

let lastComment = null
let pagei = 1;

function BasketAddRemoveSub({item}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();

    //states
    const [loading,set_loading] = useState(false)


    useEffect(()=>{

    },[])

    const addToBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await AddBasket(merchantId,pId,item)
        // console.log("Add : ",response)
    }

    const removeFromBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await RemoveBasket(merchantId,pId)
        // console.log("Remove : ",response)
    }

    //functions
    const inc = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if(basket.find(product=>product.product.uid===item.uid)){
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count+1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket",JSON.stringify(filter));
        }else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product:item,count:1}]);
            //storage change
            localStorage.setItem("basket",JSON.stringify([...basket, {product:item,count:1}]));
        }

    }

    const dec = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }
        //Remove API
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product=>product.product.uid===item.uid);
        if(find){
            //exist
            if(find.count>0){
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count-1} : pro)

                if(find.count===1){
                    //context change
                    setBasket(basket.filter(product=>product.product.uid!==item.uid))
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
                }else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(filter));
                }
            }else {
                //context change
                setBasket(basket.filter(product=>product.product.uid!==item.uid))
                //storage change
                localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
            }
        }

    }

    const remove = () =>{
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product=>product.product.uid!==item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(()=>{
            localStorage.setItem("basket",JSON.stringify(basket));
        },500)
    }

    const checkCount = () => {
        let basket_count = basket.find(product=>product.product.uid===item.uid);
        if(basket_count){
            return basket_count.count;
        }
        return 0;
    }

    return(
        <div className="add-remove-section-sub">
            {checkCount()>0?<>
                <i className="fa fa-minus" onClick={dec}></i>
                <span className="product-count-number">
                    {!loading?checkCount():<i className="fa fa-spinner fa-spin"></i>}
                </span>
            </>:null}
            {/*<span>{checkCount()}</span>*/}
            {item.stock>checkCount()?<i className="fa fa-plus" onClick={inc}></i>:<span className="stock-over">ناموجود</span>}
        </div>
    )
}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}


function OnlineSubCatCard({catId,getCats,cat,merchantId}) {
    //hooks
    const history = useHistory();
    const ref = useRef(null);
    const isVisible = useOnScreen(ref);
    const [vis,set_vis] = useState(false);

    useEffect(()=>{
        console.log("vis",cat.uid)
        if(!vis && isVisible && lastComment && cat.uid===lastComment.uid){
            pagei = pagei+1;
            // window.sub= window.sub+1;
            // getCommentListPaginate()
            getCats(merchantId,catId,window.sub);
            set_vis(true)
            console.log("page next")
        }
    },[isVisible])

    return(
        <div className="online-sub-categories-item"   ref={ref}>
            <BasketAddRemoveSub item={cat}/>
            {/*<div className="add-re-section">*/}
            {/*    /!*<i className="fa fa-plus"></i>*!/*/}
            {/*    <div className="count">1</div>*/}
            {/*    <i className="fa fa-trash"></i>*/}
            {/*</div>*/}
            <div className="info-section" onClick={()=>{
                history.push(`/online-store-product/${merchantId}/${cat.uid}`)
            }}>
                <span>{cat.name}</span>
                <div className="price-section">
                    <span style={{direction:"rtl"}}  className="original-price">{numberWithCommas(cat.price_original)} </span>
                    <span style={{direction:"rtl"}}  className="price">{numberWithCommas(cat.price)} ریال </span>
                </div>
            </div>
            <div className="img-section" onClick={()=>{
                history.push(`/online-store-product/${merchantId}/${cat.uid}`)
            }}>
                <img src={cat.image} alt=""/>
                {cat && cat.discount_percentage!==0?
                <div className="off">
                    {cat.discount_percentage+" % "}
                </div>:null}
            </div>
        </div>
    )
}

var page = 1;
window.sub = 1;

function OnlineStoreSubCat() {
    //hooks
    const history = useHistory();
    const { merchantId,catId } = useParams();


    //states
    const [cats,set_cats] = useState([]);

    //filter state
    const [filterModal,set_filterModal] = useState(false)
    const [sortModal,set_sortModal] = useState(false)
    const [sortObj,set_sortObj] = useState({label:"جدیدترین",value:"ordering=-created"})
    const [sortList,set_sortList] = useState([
        {label:"پرتخفیف ترین",value:"discount_descending=true"},
        {label:"ارزانترین",value:"ordering=price"},
        {label:"گرانترین",value:"ordering=-price"},
        {label:"جدیدترین",value:"ordering=-created"},
    ])

    const [startPrice,set_startPrice] = useState(0)
    const [endPrice,set_endPrice] = useState(5000000000)
    const [maxPrice,set_maxPrice] = useState(5000000000)

    const [rangSwitch,set_rangSwitch] = useState(true)

    const [available,set_available] = useState(false)
    const [checkListState,set_checkListState] = useState(true)

    const [brands, set_brands] = useState([])


    const brandQuery = () =>{
        let brandQuery = "";
        selBra.forEach(item=>{brandQuery+="&brand__uid="+item.uid})
        selBra.forEach(item=>{brandQuery+="&brand__uid="+item.uid})
        selBra.forEach(item=>{brandQuery+="&brand__uid="+item.uid})
        return brandQuery;
    }


    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        console.log("scroll : ",doc.scrollTop + doc.clientHeight);
        if(doc.scrollTop + doc.clientHeight == doc.scrollHeight) {
            console.log("bottonnnnn");
            getCats(merchantId,catId,window.sub);
        }
    }

    const resetSortFilter = async () =>{
        set_sortObj({label:"جدیدترین",value:"ordering=-created"})
        await set_endPrice(maxPrice)
        await set_startPrice(0)
        set_rangSwitch(false)
        setTimeout(()=>{
            set_rangSwitch(true)
            window.sub = 1
            set_cats([])
            set_available(false)
            selBra = []
            set_checkListState(false)
            getCatsReset(merchantId,catId,1);
            set_filterModal(false)
        },1000)
    }

    useEffect(()=>{
        //handle scroll arrived to Top
        window.sub = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])

    useEffect(()=>{
        if(merchantId && catId){
            getCats(merchantId,catId,window.sub);
        }

    },[]);

    const getCats = async (merId,caId,pagei) =>{
        const response = await StoreOnlineSubCatsData(merId,caId,pagei,sortObj.value,startPrice,endPrice,available,brandQuery());
        // console.log("Catss : ",response.data);
        if(response.data.results.length>0){
            set_cats((list)=>[...list,...response.data.results]);
            window.sub= window.sub+1;
            if(response.data.brands) {
                set_brands(response.data.brands)
            }
        }else{
            window.sub = window.sub -1;
        }

        if(response.data.results.length > 8){
            lastComment = response.data.results[response.data.results.length-1]
        }

    }

    const getCatsReset = async (merId,caId,pagei) =>{
        const response = await StoreOnlineSubCatsData(merId,caId,1,"ordering=-created",0,maxPrice,false,brandQuery());
        set_checkListState(true)
        // console.log("Catss : ",response.data);
        if(response.data.results.length>0){
            set_cats((list)=>[...list,...response.data.results]);
            window.sub= window.sub+1;
            if(response.data.brands) {
                set_brands(response.data.brands)
            }
        }else{
            window.sub = window.sub -1;
        }
    }

    const back= ()=>{

    }

    const addToBrandsFilter = (item) =>{
        console.log("brand add : ",item);
        // set_selectedBrands(list=>[...list,item])
        selBra = [...selBra,item]
    }
    const removeFromBrandsFilter = (brand) =>{
        console.log("brand remove : ",brand);
        selBra = selBra.filter(item => item.uid !== brand.uid)
        // set_selectedBrands(selectedBrands.filter(item => item.uid !== brand.uid))
    }

    const checkExistBrand = (uid) => {
        let res = selBra.find(item => item.uid === uid)
        return res ? true : false;
    }

    const { height, width,mobileWidth } = useWindowDimensions();

    return(
        <div className="online-store-cat" style={{paddingTop:85}}>
            <Rodal
                customStyles={{ height: 'auto', bottom: 'auto',zIndex:2001, top: '50%', transform: 'translateY(-50%)',width:'300px'}}
                closeMaskOnClick={false}
                showCloseButton={false}
                animation={"zoom"} visible={filterModal} onClose={()=>set_filterModal(false)}>
                <div className="modal-filter-container">
                    <div className="approve_btn" onClick={()=>{
                        window.sub = 1
                        set_cats([])
                        getCats(merchantId,catId,1);
                        set_filterModal(false)
                    }}>
                        <span>مشاهده</span>
                    </div>
                    <div className="modal-filter-item" style={{marginTop:0}}>
                        <div className="modal-filter-label" style={{marginBottom:20,marginTop:20}}>
                            <span>محدوده قیمت </span>
                            <i className="fa fa-star"></i>
                        </div>
                        <div className="choose-price">
                            <span>{numberWithCommas(startPrice)} ریال </span>
                            <span>تا</span>
                            <span>{numberWithCommas(endPrice)} ریال </span>
                        </div>
                        { rangSwitch?<RangeSlider
                            defaultValue={{start: startPrice, end: endPrice}}
                            step={1}
                            min={0}
                            startTabIndex={0}
                            style={{width:'100%'}}
                            max={maxPrice}
                            onChange={(e)=>{
                                set_startPrice(e.value.start.toFixed())
                                set_endPrice(e.value.end.toFixed())
                            }}
                        >
                            {/*{[0,  100].map((perc, i) => (*/}
                            {/*    <SliderLabel*/}
                            {/*        key={i}*/}
                            {/*        position={perc}*/}
                            {/*    >*/}
                            {/*        {perc.toString()}*/}
                            {/*    </SliderLabel>*/}
                            {/*))}*/}
                        </RangeSlider>:null}
                    </div>

                    {brands.length>0?<div className="modal-filter-item">
                        <div className="modal-filter-label">
                            <span>برندها</span>
                            <i className="fa fa-star"></i>
                        </div>
                        {checkListState?<div className="modal-filter-list">
                            {brands.map(brand => {
                                return (
                                    // <BrandsItem remove={removeFromBrandsFilter} add={addToBrandsFilter} brand={brand}/>
                                    <div className="modal-filter-list-item">
                                        <span>{brand.name}</span>
                                        <input type="checkbox"   name="" id=""
                                               onClick={()=>{
                                                   if(!checkExistBrand(brand.uid)){
                                                       addToBrandsFilter(brand)
                                                   }else{
                                                       removeFromBrandsFilter(brand)
                                                   }
                                               }}
                                        />
                                    </div>
                                )
                            })}

                        </div>:null}
                    </div>:null}

                    {/*item*/}


                    <div className="modal-filter-item">
                        <div className="modal-filter-label">
                            <span>موجود بودن</span>
                            <i className="fa fa-list"></i>
                        </div>
                        <div className="modal-filter-list">
                            <div className="modal-filter-list-item">
                                <span>موجود</span>
                                <input
                                    onClick={()=>{
                                        set_available(!available)
                                    }}
                                    type="checkbox" name="" id="" checked={available}/>
                            </div>
                        </div>
                    </div>

                </div>


            </Rodal>


            <Rodal
                customStyles={{ height: 'auto', bottom: 'auto',zIndex:2001, top: '50%', transform: 'translateY(-50%)',width:'300px'}}
                closeMaskOnClick={false}
                showCloseButton={false}
                animation={"zoom"} visible={sortModal} onClose={()=>set_sortModal(false)}>

                <div className="approve_btn" onClick={
                    ()=>{
                        window.sub = 1
                        set_cats([])
                        getCats(merchantId,catId,1);
                        set_sortModal(false)
                    }
                }>
                    <span>مشاهده</span>
                </div>
                <div className="sort-modal-container">
                    <div className="sort-modal-title">
                        <span>مرتب سازی </span>
                        <i className="fa fa-sort"></i>
                    </div>
                    <div className="sort-modal-list">
                        {sortList.map(item=>{
                            return(
                                <div className="sort-modal-list-item">
                                    <span>{item.label}</span>
                                    <input type="radio" name="sortSub" checked={item.label===sortObj.label?true:false} id="" onClick={()=>{
                                        set_sortObj(item)
                                    }}/>
                                </div>
                            )
                        })}
                    </div>
                </div>

            </Rodal>


            <div className="filter-box-sub" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                <div className="filter-box-row" >
                    <div className="filter-box-item" onClick={()=>{set_sortModal(true)}}>
                        <span>{sortObj.label}</span>
                        <i className="fa fa-sort"></i>
                    </div>
                    <div className="filter-box-item" onClick={()=>{set_filterModal(true)}}>
                        <span>فیلتر</span>
                        <i className="fa fa-sliders"></i>
                    </div>

                    <span className="clear_filters" onClick={()=>{
                        resetSortFilter()
                    }}>
                      پاک کردن
                  </span>
                </div>
            </div>


            <OnlineSearch merchantId={merchantId}/>
            <div className="online-sub-categories-container">
            {cats && cats.map(item=>{
                return(
                    <OnlineSubCatCard catId={catId} getCats={getCats} merchantId={merchantId} cat={item}/>
                )
            })}
            </div>
        </div>
    )
}

export {OnlineStoreSubCat};
